module.exports = __webpack_public_path__ + "static/media/cross-the-street.03d07fed.jpg";